import React from "react";

function FlagIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2861_3408)">
        <path
          d="M4.12317 18.5473V11.8624M4.12317 11.8624V3.50619M4.12317 11.8624L6.18714 11.4496C7.5666 11.1747 8.99617 11.3059 10.3026 11.8273C11.7178 12.393 13.2753 12.4985 14.7539 12.1289L14.9327 12.0846C15.1866 12.0213 15.412 11.8748 15.5731 11.6686C15.7342 11.4624 15.8218 11.2082 15.8218 10.9465V4.79053C15.8217 4.63826 15.787 4.48799 15.7202 4.35114C15.6534 4.21429 15.5564 4.09444 15.4364 4.0007C15.3164 3.90695 15.1766 3.84177 15.0276 3.81009C14.8787 3.77841 14.7245 3.78108 14.5767 3.81788C13.2135 4.15845 11.7776 4.06079 10.473 3.53878L10.3026 3.4711C8.99642 2.94989 7.56716 2.81869 6.18798 3.0934L4.12317 3.50619M4.12317 3.50619V1.83496"
          stroke="#424242"
          strokeWidth="1.25342"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2861_3408">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FlagIcon;
